// GiftPromotionHandler.js
'use strict';
import { connect } from 'react-redux';

import GiftPromotionHandler from '../component/GiftPromotionHandler.jsx';
import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getModalData from '../selector/getModalData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getShouldShowLivestreamCta from '../selector/getShouldShowLivestreamCta.js';
import mergeMeData from '../action/mergeMeData.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';

import {
  FEATURE_FREE_LIVESTREAM_GIFT_POPUP,
  FREE_LIVESTREAM_GIFT_POPUP_THRESHOLD_SECONDS,
  FREE_LIVESTREAM_GIFT_POPUP_LIMIT_WINDOW_SECONDS,
  FREE_LIVESTREAM_GIFT_POPUP_MAX_SHOW_COUNT,
} from '../RemoteConfigKeys.js';

function mapStateToProps(state, { streamId }) {
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const isLiveStreaming = getLiveStreamData(
    state,
    [streamId],
    'isLiveStreaming'
  );
  const streamStatus = getLiveStreamData(state, [streamId], 'status');

  const shouldShowLivestreamCta = getShouldShowLivestreamCta(state, streamId);

  const isGiftPromotionModalVisible = ['opening', 'display'].includes(
    getModalData(state, 'GiftPromotionModal', 'status')
  );

  const lastGiftTime = getOperationData(state, ['engagement'], 'giftTime');

  return {
    isAuthed,
    isLiveStreaming,
    streamStatus,
    shouldShowLivestreamCta,
    isGiftPromotionModalVisible,
    isGiftPromotionEnabled:
      getRemoteConfigData(state, FEATURE_FREE_LIVESTREAM_GIFT_POPUP) === 1,
    giftPromotionDelaySeconds: getRemoteConfigData(
      state,
      FREE_LIVESTREAM_GIFT_POPUP_THRESHOLD_SECONDS
    ),
    promotionWindowDurationSeconds: getRemoteConfigData(
      state,
      FREE_LIVESTREAM_GIFT_POPUP_LIMIT_WINDOW_SECONDS
    ),
    maxPromotionDisplayCount: getRemoteConfigData(
      state,
      FREE_LIVESTREAM_GIFT_POPUP_MAX_SHOW_COUNT
    ),
    promotionDisplayCount: getMeData(state, 'giftPromotionModalShowCount'),
    promotionWindowStartTime: getMeData(
      state,
      'firstPromotionModalStartTimestamp'
    ),
    lastGiftTime,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPromotionDisplayCount: ({ count }) => {
      dispatch(
        mergeMeData({ field: 'giftPromotionModalShowCount', value: count })
      );
    },
    setPromotionWindowStartTime: ({ timestamp }) => {
      dispatch(
        mergeMeData({
          field: 'firstPromotionModalStartTimestamp',
          value: timestamp,
        })
      );
    },
    setIsGiftPromotionModalVisible: isVisible => {
      if (isVisible) {
        dispatch(addModal({ id: 'GiftPromotionModal' }));
      } else {
        dispatch(
          removeModals({
            ids: ['GiftPromotionModal'],
            transitionStatus: 'closing',
          })
        );
      }
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GiftPromotionHandler);
